import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <span className={styles.code} aria-hidden="true">
        404
      </span>
      <h1 className={styles.heading}>This address doesn&apos;t resolve.</h1>
      <p className={styles.body}>
        The page you&apos;re looking for doesn&apos;t exist. It may have been moved, or
        the link might be incorrect.
      </p>
      <Link to="/" className={styles.link}>
        Back to wallet
      </Link>
    </div>
  );
}
